<template>
    <div class="modal fade show custom-modal modal-show" id="confirmDocument" role="dialog"  v-if="isSuccess">
      <div class="modal-dialog modal-dialog-centered model-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="closeModal()">&times;</button>
            </div>
            <div class="tick-icon">
                <img src="@/assets/images/done.png" class="tick" />
            </div>
          <div class="modal-body text-center pb-0">
             <p class="margin-style">Your documents have been successfully uploaded</p>
            <p>For <b>PIN : {{pin}}</b></p>
          </div>
          <div class="col-12 modal-footer pb-4">
            <div class="modal-footer">
              <button type="button" class="bgc-btn-primary"
                @click="closeModal()"> OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "DocConfirmationSuccessModal",
  props : ['pin', 'isSuccess'],
  methods : {
    closeModal(){
      this.$emit('closeSuccessPinModal');
    }
  }
};
</script>

<style scoped>
h5 {
  font-weight: 600;
  color: #666666;
}
button.close {
  padding-top: 13px;
  text-align: right;
}
.modal-body {
  overflow-y: hidden;
  margin-top: -20px;
}
.modal-footer {
  border-top: 0 none;
  text-align: center;
  display: block;
}
.margin-style {
  margin-top: 30px;
}
.tick-icon{
    text-align: center;
    padding-top: 25px;
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
</style>